<template>
  <div class="sign">
    <div class="container"> 
      <img src="../assets/logo_l@svg.svg" alt="六角西餐聽" class="logo" />
      <p class="subtitle">享受美食好味道</p>
      <div class="warp clearfix">
        <h2 class="title">REGISTER</h2>
        <div class="trems col-12 col-6-t">
          <h2 class="tremsTitle">就是這樣條款：</h2>
          <p class="des">Mauris non tempor quam, et lacinia sapien. Mauris accumsan eros eget libero posuere vulputate. Etiam elit elit, elementum sed varius at, adipiscing vitae est. Sed nec felis pellentesque, lacinia dui sed, ultricies sapien...</p>
        </div>
        <form class="form col-12 col-6-t">
          <label>Email Address*<br><input type="email" placeholder="Email..." required></label>
          <label>Password*<br>
            <input type="password" placeholder="Password..." required>
            <input type="password" placeholder="Password..." required>
          </label>
          <router-link to="/login" class="member">已經有帳號了 ?</router-link>
          <div class="btnGroup">
            <button class="signupBtn">註冊</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'signPage'
  }
</script>

<style lang="scss" scoped>
  .sign {
    padding: 50px 0;
    background-color: #EFE9E7;
    .container {
      width: 90%;
      max-width: 620px; 
    }
  }
  .logo {
    display: block;
    margin: 0 auto;
  }
  .subtitle {
    margin-top: 5px;
    color: #3D1101;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }
  .warp {
    margin-top: 35px;
    padding: 15px;
    border-top: 3px solid #FF5E45;
    box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.16);
    .title {
      margin-bottom: 1rem;
      font-size: 18px;
    }
  }
  .trems {
    margin-bottom: 16px;
    .tremsTitle {
      font-weight: normal;
      font-size: 18px;
      color: #3D1101;
    }
  }
  .form {
    label {
      display: inline-block;
      width: 100%;
      color: #3D1101;
      &:nth-child(2) {
        margin-top: 16px;
      }
    }
    input {
      height: 32px;
      width: 100%;
      margin-top: 3px;
      padding: 0 9px;
      border: 1px solid #CCCCCC;
      border-radius: 3px;
      box-shadow: inset 0px 1px 0px 0px #ECECEC;
      &:nth-child(3) {
        margin-top: 5px;
      }
    }
    .member {
      color: #FF5E45;
      font-size: 14px;
    }
    .btnGroup {
      display: flex;
      justify-content: flex-end;
      margin-top: 2rem;
      .signupBtn {
        width: 125px;
        height: 2rem;
        padding: 6px 27px;
        border: none;
        border-radius: 3px;
        color: #fff;
        background: #F56C23;
      }
    }
  }
  @media (min-width: 768px) {
    .trems {
      padding-right: 1rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/signupPage.vue